


















































































































































































































import Vue from "vue";
import Store, { InvoiceFlowStore } from "../services/InvoiceFlowStore";
import api from "../services/InvoiceFlowApi";
import VatDivisionDisplay from "../models/VatDivisionDisplay";
import VatDivision from "../models/VatDivision";
import Tax, { taxDefaultProps } from "@/modules/generalIngoingInvoice/models/Tax";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import VatAnaliticsDetails from "./VatAnaliticsDetails.vue";
import IconButton from "@/components/IconButton.vue";
import VatDivisionItemGroup from "../models/VatDivisionItemGroup";
import eventBus from "@/services/eventBus";
import { t } from "@/plugins/i18n";

interface Data {
  geni: number;
  store: InvoiceFlowStore;
  reCreateVatDivConfirm: boolean;
}

interface Methods {
  taxChanged(item: VatDivisionDisplay): void;
  emit(x: VatDivisionDisplay): void;
  showDetails(item: VatDivisionItemGroup): void;
  substractableChanged(x: VatDivisionDisplay): void;
  reCreateVatDivs(): void;
}

interface Computed {
  vatDivColumns: any;
  vatDivItems: any;
  vatDivItemGroupColumns: any;
  vatDivItemGroupItems: any;
  vatDivisionChanged: boolean;
}

interface Props {
  disabled: boolean;
  isSubtractableEdit: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    MoneyDisplay,
    VatAnaliticsDetails,
    IconButton,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isSubtractableEdit: {
      type: Boolean,
      default: false,
    }
  },

  data(): Data {
    return {
      geni: 0,
      store: Store,
      reCreateVatDivConfirm: false,
    };
  },

  computed: {
    vatDivColumns: () => [
      {
        field: "taxName",
        title: t("InvoiceFlow_SzamlaTetelAfakulcsa"),
      },
      {
        width: 105,
        field: "taxDegree",
        title: t("InvoiceFlow_SzamlaTetelAfa_2"),
      },
      {
        width: 115,
        field: "substractable",
        title: t("InvoiceFlow_AfabevallasbanSzerepeljen"),
        editor: "boolean",
        cell: "substractTemplate",
      },
      {
        width: 175,
        field: "tax2",
        title: t("InvoiceFlow_AfabevallasbanSzereploAfakulcs"),
        cell: "tax2Template",
      },
      {
        field: "netto",
        title: t("InvoiceFlow_AfabevallasbanSzereploNetto"),
        cell: "nettoTemplate",
      },
      {
        field: "brutto",
        title: t("InvoiceFlow_AfabevallasbanSzereploBrutto"),
        cell: "bruttoTemplate",
      },
      {
        field: "vat",
        title: t("InvoiceFlow_AfabevallasbanSzereploAfa"),
        cell: "vatTemplate",
      },
      {
        width: 60,
        field: "currency",
        title: t("Penznem"),
      },
      {
        width: 95,
        field: "isInvest",
        title: t("InvoiceFlow_Beruhazas"),
        editor: "boolean",
        cell: "investTemplate",
        headerClassName: "right_text",
        className: "right_text",
      },
      {
        width: 95,
        field: "isService",
        title: t("Szolgaltatas"),
        editor: "boolean",
        cell: "serviceTemplate",
        headerClassName: "right_text",
        className: "right_text",
      },
      {
        width: 95,
        field: "backDemand",
        title: t("InvoiceFlow_Levonhato"),
        editor: "boolean",
        cell: "backDemandTemplate",
        headerClassName: "right_text",
        className: "right_text",
      },
      {
        width: 0,
      },
    ],

    vatDivItemGroupColumns: () => [
      {
        width: 50,
        cell: "detailsButtonTemplate",
      },
      {
        field: "taxName",
        title: t("InvoiceFlow_TetelAfakulcsCsoport"),
      },
      {
        width: 0,
      },
    ],

    vatDivItems() {
      return this.store.vatDivisionsDisplay;
    },

    vatDivItemGroupItems() {
      return this.store.vatDivisionItemGroups;
    },

    vatDivisionChanged() {
      return this.store.vatDivisions.some((division, i) =>
        division.substractable != this.store.originalVatDivisions[i].substractable ||
        division.tax2 != this.store.originalVatDivisions[i].tax2 ||
        division.isInvest != this.store.originalVatDivisions[i].isInvest ||
        division.backDemand != this.store.originalVatDivisions[i].backDemand
      );
    }
  },

  async beforeMount() {
    this.geni = Number(this.$route.params.invoiceId);
    Store.setVatAnalitycsStore(this.geni);
  },
  methods: {
    substractableChanged(x: VatDivisionDisplay){
      this.emit(x);

      const uniqueItems = this.store.vatDivisionsDisplay.filter(y => 
        y.taxId == x.taxId &&
        y.substractable == x.substractable &&
        y.isInvest == x.isInvest &&
        y.backDemand == x.backDemand &&
        y.isService == x.isService &&
        y.tax2 == x.tax2 &&
        y.id != x.id
      );

      uniqueItems.forEach(y => {
        y.substractable = !x.substractable;
        this.emit(y);
      });
    },

    taxChanged(item) {
      const taxDegree = Store.taxes.find(i => i.id == item.tax2) ?? taxDefaultProps;
      item.vat = Number((item.netto * (taxDegree.degree / 100)).toFixed(2));
      item.brutto = item.netto + item.vat;
      this.emit(item);
    },

    emit(x: VatDivisionDisplay) {
      this.$emit("itemChanged", x);
    },

    showDetails(item: VatDivisionItemGroup) {
      item.selected = !item.selected;
    },

    async reCreateVatDivs() {        
      await this.store.changeInVatCount(
        this.store.vatDivisionItemGroups.flatMap((i) => i.items),
        true
      );
      eventBus.$emit("FlowAccountingPage:preAccounting");
      this.reCreateVatDivConfirm = false;
    }
  },

    watch: {
    'store.vatDivisions': {
      deep: true,
      handler() {
        this.store.runPreAccounting = this.vatDivisionChanged;
      }
    }
  },
});
